// RELY - Corporate Footer
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LEGAL_CONFIG } from '../../config/legal';

const Footer = ({ reserveMobileDockClearance = true }) => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const links = [
    {
      id: 'terms',
      to: '/terms',
      label: t('footer.terms', 'Términos y Condiciones'),
      shortLabel: t('footer.termsShort', 'Términos'),
    },
    {
      id: 'privacy',
      to: '/privacy',
      label: t('footer.privacy', 'Política de Privacidad'),
      shortLabel: t('footer.privacyShort', 'Privacidad'),
    },
    {
      id: 'cookies',
      to: '/cookies',
      label: t('footer.cookies', 'Cookies'),
      shortLabel: t('footer.cookies', 'Cookies'),
    },
    {
      id: 'refund',
      to: '/refund-policy',
      label: t('footer.refund', 'Reembolsos'),
      shortLabel: t('footer.refund', 'Reembolsos'),
    },
    {
      id: 'blog',
      to: '/blog',
      label: t('footer.blog', 'Blog'),
      shortLabel: t('footer.blog', 'Blog'),
    },
  ];

  return (
    <footer
      data-testid="app-footer"
      data-density="compact"
      data-mobile-dock-clearance={
        reserveMobileDockClearance ? 'reserved' : 'none'
      }
      className={[
        'border-t border-[var(--rely-border-subtle)] bg-transparent pt-4 text-[var(--rely-text-muted)] md:pb-0',
        'pb-4',
      ].join(' ')}
    >
      <div className="mx-auto max-w-7xl px-0 sm:px-2">
        <div className="flex flex-col items-start justify-between gap-2 sm:flex-row sm:items-center">
          <p
            data-testid="footer-copyright"
            className="text-xs leading-5 text-[var(--rely-text-muted)]"
          >
            © {currentYear} {LEGAL_CONFIG.company.name}
            <span
              data-testid="footer-rights"
              className="sr-only sm:not-sr-only"
            >
              . {t('footer.rights', 'Todos los derechos reservados.')}
            </span>
          </p>

          <nav
            aria-label={t('footer.legalLinks', 'Legal links')}
            className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs sm:justify-end"
          >
            {links.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                aria-label={link.label}
                className="text-[var(--rely-text-muted)] transition-colors duration-200 hover:text-[var(--rely-text-strong)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--rely-surface-page)]"
              >
                <span
                  data-testid={`footer-link-short-${link.id}`}
                  aria-hidden="true"
                  className="sm:hidden"
                >
                  {link.shortLabel}
                </span>
                <span
                  data-testid={`footer-link-full-${link.id}`}
                  aria-hidden="true"
                  className="hidden sm:inline"
                >
                  {link.label}
                </span>
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
